export default [
  {
    path: '/modules/financial/integracoes',
    name: 'integracoes',
    component: () => import('@/views/modules/financial/integracoes/IntegracaoGatewayList.vue'),
    meta: {
      action: ['ROLE_INTEGRACAO_CONSULTAR'],
      resource: 'ACL',
      pageTitle: 'Integrações Bancárias',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Integrações', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/integracoes/add',
    name: 'integracoes-add',
    component: () => import('@/views/modules/financial/integracoes/IntegracaoGatewayForm.vue'),
    meta: {
      action: ['ROLE_INTEGRACAO_INSERIR'],
      resource: 'ACL',
      pageTitle: 'Nova Integração',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Integrações', to: { name: 'integracoes' } },
        { text: 'Nova', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/integracoes/edit/:id',
    name: 'integracoes-edit',
    component: () => import('@/views/modules/financial/integracoes/IntegracaoGatewayForm.vue'),
    meta: {
      action: ['ROLE_INTEGRACAO_ATUALIZAR'],
      resource: 'ACL',
      pageTitle: 'Editar Integração',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Integrações', to: { name: 'integracoes' } },
        { text: 'Editar', active: true },
      ],
    },
  },
]
